import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Api from "../utils/api";
import registerTranslations from "../locales/registerTranslations";
import { LanguageContext } from "../locales/LanguageContext";

const Register = () => {
  const { lang } = useContext(LanguageContext);
  const t = registerTranslations[lang] || {};
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    // roleId will be set by backend
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      const data = await Api.post("auth/register", form);
      localStorage.setItem("token", data.token);
      setSuccess(t.success);
      setForm({ name: "", email: "", password: "" });
      // Role-based redirect
      const userRole = data.user?.role || data.user?.roleId?.name;
      if (userRole === "Admin") {
        navigate("/admin/dashboard");
      } else {
        navigate("/profile");
      }
    } catch (err) {
      setError(err.message || t.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>{t.pageTitle} | AKAAL KIDS</title>
      </Helmet>
      {/* Hero Banner */}
      <div
        style={{
          width: "100%",
          background: "linear-gradient(90deg, #f6815e 0%, #f6b93b 100%)",
          color: "#fff",
          padding: "38px 0 24px 0",
          textAlign: "center",
          marginBottom: 32,
          boxShadow: "0 4px 24px #f6815e22",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <h1
          style={{
            fontWeight: 900,
            fontSize: "2.6rem",
            letterSpacing: 1,
            marginBottom: 11,
            textShadow: "0 2px 12px #f6815e55",
          }}
        >
          {t.heroTitle}
        </h1>
        <div style={{ fontSize: 20, fontWeight: 500, opacity: 0.96 }}>
          <span role="img" aria-label="register">
            📝
          </span>{" "}
          {t.heroDesc}
        </div>
      </div>
      <div className="container py-5" style={{ maxWidth: 400 }}>
        <form
          onSubmit={handleSubmit}
          className="bg-white p-4 rounded shadow-sm"
        >
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder={t.namePlaceholder}
              name="name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <input
              type="email"
              className="form-control"
              placeholder={t.emailPlaceholder}
              name="email"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <input
              type="password"
              className="form-control"
              placeholder={t.passwordPlaceholder}
              name="password"
              value={form.password}
              onChange={handleChange}
              required
            />
          </div>
          {error && <div className="text-danger mb-3">{error}</div>}
          {success && <div className="text-success mb-3">{success}</div>}
          <button
            type="submit"
            className="btn btn-primary w-100 mb-2"
            disabled={loading}
          >
            {loading ? t.registering : t.registerBtn}
          </button>
        </form>
      </div>
    </>
  );
};

export default Register;
